import warnImg from '@/assets/images/teacher-out-warning.png'
import Modal from '@/components/Modal'
import { videoViolationState } from '@/store/room'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { useRecoilState } from 'recoil'

export default function Index() {
  const [videoViolation, setVideoViolation] = useRecoilState(videoViolationState)
  return (
    <Container>
      {/* 鉴黄老师提醒弹框 */}
      <Modal show={videoViolation === 2} header="" confirmText="我知道了" confirm={() => setVideoViolation(0)} cancelText="">
        <div className="text-center">
          <img className="m-auto w-[64px] h-[64px]" src={warnImg} />
          <h3 className="my-[5px]">注意着装</h3>
          <div className="my-[10px]">
            <p className=" text-[14px]">
              请调整领口或更换着装后
              <br />
              重新进入教室
            </p>
          </div>
        </div>
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)``
